var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialIg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28 0H22.72C27.84 0 32 4.16 32 9.28V22.72C32 27.8452 27.8452 32 22.72 32H9.28C4.16 32 0 27.84 0 22.72V9.28C0 4.1548 4.1548 0 9.28 0ZM8.96 3.2C5.77884 3.2 3.2 5.77884 3.2 8.96V23.04C3.2 26.224 5.776 28.8 8.96 28.8H23.04C26.2212 28.8 28.8 26.2212 28.8 23.04V8.96C28.8 5.776 26.224 3.2 23.04 3.2H8.96ZM26.4 7.6C26.4 6.49543 25.5046 5.6 24.4 5.6C23.2954 5.6 22.4 6.49543 22.4 7.6C22.4 8.70457 23.2954 9.6 24.4 9.6C25.5046 9.6 26.4 8.70457 26.4 7.6ZM16 8C20.4183 8 24 11.5817 24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8ZM11.2 16C11.2 13.349 13.349 11.2 16 11.2C18.651 11.2 20.8 13.349 20.8 16C20.8 18.651 18.651 20.8 16 20.8C13.349 20.8 11.2 18.651 11.2 16Z",
    fill: "#2C353A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialIg);
export default __webpack_public_path__ + "static/media/icon_social_IG.124d287f86983284933d15aad3068868.svg";
export { ForwardRef as ReactComponent };